import Vue from 'vue';
import { isFunction } from 'lodash-es';

export const SET = (state, { key, value }) => {
	state[key] = value;
};

export const SET_ITEM = (state, { key, find = () => {}, value }) => {
	let index = (state[key] || []).findIndex(find);
	if (~index) Vue.set(state[key], index, isFunction(value) ? value(state[key][index]) : value);
	else state[key].push(isFunction(value) ? value() : value);
};
